import React from "react";
import { Link } from "react-router-dom";
import { SectionHead } from "./SectionParts";
import { PlayCircle, Video } from "lucide-react";
import { CategoryPill } from "./ArticleCard";

export default function VideoNews({ articles = [] }) {
  const items = articles.slice(0, 4);
  if (!items.length) return null;

  return (
    <section className="my-16" data-testid="video-section">
      <SectionHead title="वीडियो न्यूज" subtitle="देखें खास रिपोर्ट्स" icon={<Video className="h-4 w-4" />} />
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
        {items.map((a) => (
          <Link key={a.id} to={`/article/${a.slug}`} data-testid={`video-card-${a.id}`} className="bodh-card group relative h-64 rounded-2xl overflow-hidden bg-zinc-900 block">
            {a.cover_image && <img src={a.cover_image} alt={a.title} className="absolute inset-0 w-full h-full object-cover opacity-90 group-hover:scale-[1.05] group-hover:opacity-100 transition-all duration-700" />}
            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-transparent" />
            <div className="absolute top-3 left-3"><CategoryPill slug={a.category} /></div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="h-16 w-16 rounded-full bg-white/95 flex items-center justify-center shadow-2xl group-hover:scale-110 transition-transform">
                <PlayCircle className="h-10 w-10 text-[#E30613]" fill="currentColor" stroke="none" />
              </div>
            </div>
            <div className="absolute bottom-0 p-4 right-0 left-0">
              <h3 className="font-devanagari font-bold text-white text-sm leading-snug line-clamp-2">{a.title}</h3>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
